import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

const ICON_MAP = {
    'add-file': ['fal', 'fa-file-plus'],
    'alert-full': ['fas', 'fa-bell'],
    'angle-down': ['fal', 'fa-angle-down'],
    'angle-left': ['fal', 'fa-angle-left'],
    'angle-right': ['fal', 'fa-angle-right'],
    'angle-up': ['fal', 'fa-angle-up'],
    'arrow-left': ['far', 'fa-arrow-left'],
    'arrow-right': ['far', 'fa-arrow-right'],
    'atom-alt': ['fal', 'fa-atom-alt'],
    'badge-dollar': ['far', 'fa-badge-dollar'],
    'bed-front': ['fal', 'fa-bed-front'],
    'business-time': ['fal', 'fa-business-time'],
    'calendar-plus': ['fal', 'fa-calendar-plus'],
    'calendar-star': ['fal', 'fa-calendar-star'],
    'calendar-week': ['fal', 'fa-calendar-week'],
    'chart-mixed': ['fal', 'fa-chart-mixed'],
    'check-regular': ['far', 'fa-check'],
    'check-solid': ['fas', 'fa-check'],
    'checkbox-false': ['fal', 'fa-square'],
    'checkbox-true': ['fal', 'fa-check-square'],
    'checkbox-true-filled': ['fas', 'fa-check-square'],
    'circle-arrow-down': ['fas', 'fa-arrow-circle-down'],
    'circle-arrow-left': ['fas', 'fa-arrow-circle-left'],
    'circle-arrow-right': ['fas', 'fa-arrow-circle-right'],
    'circle-arrow-up': ['fas', 'fa-arrow-circle-up'],
    'circle-check': ['far', 'fa-check-circle'],
    'circle-solid-full': ['fas', 'fa-circle'],
    'cross-circle': ['fal', 'fa-times-circle'],
    'cross-solid-circle': ['fas', 'fa-times-circle'],
    'double-check': ['fal', 'fa-check-double'],
    'down-solid': ['fas', 'fa-chevron-down'],
    'driving-licence': ['fal', 'fa-steering-wheel'],
    'edit-alt': ['fal', 'fa-pen-to-square'],
    'eye-slash': ['fal', 'fa-eye-slash'],
    'folder-plus': ['far', 'fa-folder-plus'],
    'globe-africa': ['fal', 'fa-globe-africa'],
    'globe-europe': ['fal', 'fa-globe-europe'],
    'graduation-cap': ['fal', 'fa-graduation-cap'],
    'grin-stars': ['fal', 'fa-grin-stars'],
    'head-side-brain': ['fal', 'fa-head-side-brain'],
    'heart-full': ['fas', 'fa-heart'],
    'heart-regular': ['far', 'fa-heart'],
    'laptop-code': ['fal', 'fa-laptop-code'],
    'leaf-heart': ['fal', 'fa-leaf-heart'],
    'location-pin': ['fa-light', 'fa-location-dot'],
    'money-bill-transfer': ['fal', 'fa-money-bill-transfer'],
    'pencil-paintbrush': ['fal', 'fa-pencil-paintbrush'],
    'plus-circle': ['fal', 'fa-plus-circle'],
    'question-circle': ['fal', 'fa-question-circle'],
    'radio-false': ['fal', 'fa-circle'],
    'radio-true': ['fal', 'fa-dot-circle'],
    'scale-balanced': ['fal', 'fa-scale-balanced'],
    'search-regular': ['far', 'fa-search'],
    'sign-out': ['fal', 'fa-sign-out-alt'],
    'sliders-regular': ['far', 'fa-sliders-h'],
    'star-full': ['fas', 'fa-star'],
    'star-shooting': ['fal', 'fa-star-shooting'],
    'student-job': ['fal', 'fa-piggy-bank'],
    'to-top': ['fal', 'fa-arrow-to-top'],
    'toggle-off': ['fal', 'fa-toggle-off'],
    'toggle-on': ['fal', 'fa-toggle-on'],
    'umbrella-beach': ['fal', 'fa-umbrella-beach'],
    'up-solid': ['fas', 'fa-chevron-up'],
    'user-chart': ['fal', 'fa-user-chart'],
    'user-friends': ['fal', 'fa-user-friends'],
    account: ['fal', 'fa-user-circle'],
    add: ['fal', 'fa-plus'],
    ads: ['fal', 'fa-briefcase'],
    alert: ['fal', 'fa-bell'],
    alerts: ['fal', 'fa-bells'],
    articles: ['fal', 'fa-newspaper'],
    attachment: ['fal', 'fa-paperclip'],
    back: ['fal', 'fa-chevron-left'],
    backpack: ['fal', 'fa-backpack'],
    bars: ['fal', 'fa-bars'],
    bicycle: ['fal', 'fa-bicycle'],
    bolt: ['fal', 'fa-bolt'],
    book: ['fal', 'fa-book'],
    calculator: ['fal', 'fa-calculator-simple'],
    calendar: ['fal', 'fa-calendar'],
    candidacies: ['fal', 'fa-users'],
    car: ['fal', 'fa-car-side'],
    carrot: ['fal', 'fa-carrot'],
    chat: ['fal', 'fa-comments'],
    check: ['fal', 'fa-check'],
    circle: ['fal', 'fa-circle'],
    clipboard: ['fal', 'fa-clipboard-list'],
    clock: ['fal', 'fa-clock'],
    close: ['fal', 'fa-times'],
    comment: ['fal', 'fa-comment'],
    company: ['fal', 'fa-building'],
    conversation: ['fal', 'fa-comment-dots'],
    copyright: ['fal', 'fa-copyright'],
    danger: ['fal', 'fa-radiation-alt'],
    date: ['fal', 'fa-calendar-day'],
    delete: ['fal', 'fa-trash'],
    down: ['fal', 'fa-chevron-down'],
    download: ['fal', 'fa-download'],
    duplicate: ['fal', 'fa-copy'],
    edit: ['fal', 'fa-pen'],
    euro: ['fal', 'fa-circle-euro'],
    expand: ['fal', 'fa-external-link'],
    facebook: ['fab', 'fa-facebook-square'],
    file: ['fal', 'fa-file-alt'],
    forward: ['fal', 'fa-chevron-right'],
    function: ['fal', 'fa-function'],
    handshake: ['fal', 'fa-handshake'],
    hashtag: ['fal', 'fa-hashtag'],
    heart: ['fal', 'fa-heart'],
    heartbeat: ['fal', 'fa-heartbeat'],
    image: ['fas', 'fa-image'],
    instagram: ['fab', 'fa-instagram'],
    internship: ['fal', 'fa-graduation-cap'],
    kot: ['fal', 'fa-house'],
    landmark: ['fal', 'fa-landmark'],
    left: ['fal', 'fa-chevron-left'],
    'left-regular': ['far', 'fa-chevron-left'],
    'right-regular': ['far', 'fa-chevron-right'],
    licence: ['fal', 'fa-id-card'],
    linkedin: ['fab', 'fa-linkedin'],
    mail: ['fal', 'fa-envelope'],
    marker: ['fal', 'fa-map-marker-alt'],
    message: ['fal', 'fa-comments'],
    messenger: ['fab', 'fa-facebook-messenger'],
    moon: ['fal', 'fa-moon'],
    more: ['fal', 'fa-chevron-down'],
    pen: ['fal', 'fa-pen'],
    phone: ['fal', 'fa-phone-alt'],
    register: ['fal', 'fa-cash-register'],
    reset: ['far', 'fa-redo-alt'],
    right: ['fal', 'fa-chevron-right'],
    rocket: ['fal', 'fa-rocket-launch'],
    save: ['fal', 'fa-save'],
    school: ['fal', 'fa-school'],
    scroll: ['fal', 'fa-scroll'],
    search: ['fal', 'fa-search'],
    send: ['fal', 'fa-paper-plane'],
    settings: ['fal', 'fa-cog'],
    share: ['fal', 'fa-share-alt'],
    sliders: ['fal', 'fa-sliders-h'],
    speaker: ['fal', 'fa-bullhorn'],
    star: ['fal', 'fa-star'],
    tiktok: ['fab', 'fa-tiktok'],
    tools: ['fal', 'fa-tools'],
    twitter: ['fab', 'fa-twitter'],
    unicorn: ['fal', 'fa-unicorn'],
    university: ['fal', 'fa-university'],
    up: ['fal', 'fa-chevron-up'],
    user: ['fal', 'fa-user'],
    vacuum: ['fal', 'fa-vacuum'],
    view: ['fal', 'fa-eye'],
    whatsapp: ['fab', 'fa-whatsapp'],
    AI: ['fal', 'fa-sparkles'],
    'circle-full': ['fal', 'fa-dot-circle'],
    cog: ['fal', 'fa-cog'],
    cross: ['fal', 'fa-times'],
    dashboard: ['fal', 'fa-gauge'],
    eye: ['fal', 'fa-eye'],
    'first-job': ['fal', 'fa-rocket-launch'],
    'fork-knife': ['fal', 'fa-fork-knife'],
    happy: ['fal', 'fa-grin-stars'],
    'heart-light': ['fal', 'fa-heart'],
    'piggy-bank': ['fal', 'fa-piggy-bank'],
    teacher: ['fal', 'fa-chalkboard-teacher']
}

const IconFactory = (props) => {
    const { icon, type, tooltip, onClick, className = '', style = {}, fontSize, color, padding, button, iconButtonClassName } = props
    const classes = ICON_MAP[icon] || ['fas', 'fa-question-circle']
    const baseStyle = {
        fontSize: fontSize || '18px',
        color: color || undefined,
        ...style
    }

    const element = (
        <i
            className={[...classes, className].filter(Boolean).join(' ')}
            style={baseStyle}
            onClick={onClick}
            aria-hidden="true"
        />
    )

    if (type === 'button' || button) {
        return (
            <IconButton
                onClick={onClick}
                className={iconButtonClassName}
                style={{ padding: padding || '12px', cursor: 'pointer' }}
            >
                {element}
            </IconButton>
        )
    }
    if (tooltip) {
        return <Tooltip title={tooltip}>{element}</Tooltip>
    }
    return element
}

IconFactory.propTypes = {
    icon: PropTypes.string.isRequired,
    type: PropTypes.string,
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    fontSize: PropTypes.string,
    color: PropTypes.string,
    padding: PropTypes.string
}

export default IconFactory
